import { getAccessToken } from 'AccessToken';
import {
	useGetOutletQuery,
	useGetTaxSchemeDetailLazyQuery,
} from 'generated/graphql';
import { amtStr } from 'helpers/numFormatter';
import React, { useEffect } from 'react';

interface Props {
	outletID;
	taxSchemeID;
	orderID;
	currencyCode;
	type;
	taxSchemeInfo;
	taxSchemeFooterInfo;
	takeaway?;
}

export enum SchemeType {
	GST = 'GST',
	ServiceCharge = 'ServiceCharge',
	SST = 'SST',
}

export const TaxSchemeComponent = (props: Props) => {
	const {
		outletID,
		taxSchemeID,
		orderID,
		currencyCode,
		type,
		taxSchemeInfo,
		taxSchemeFooterInfo,
		takeaway,
	} = props;

	const user = (() => {
		try {
			return JSON.parse(localStorage.getItem('customerInfo') || 'null');
		} catch {
			return null;
		}
	})();

	const hasAuth = !!getAccessToken() && !!user?.accountID;

	const {
		loading: outletLoading,
		data: { getOutlet } = { getOutlet: [] },
	} = useGetOutletQuery({
		skip: !outletID || !hasAuth,
		fetchPolicy: 'network-only',
		variables: { ID: outletID },
	});

	const [
		defaultTax,
		{
			data: { getTaxSchemeDetail } = {
				getTaxSchemeDetail: null,
			},
		},
	] = useGetTaxSchemeDetailLazyQuery({
		fetchPolicy: 'no-cache',
	});

	useEffect(() => {
		if (
			!hasAuth ||
			!getOutlet?.length ||
			orderID === undefined ||
			orderID === '' ||
			!user?.accountID
		) {
			return;
		}

		const schemeID =
			taxSchemeID === null || taxSchemeID === undefined
				? getOutlet[0]?.taxSchemeID
				: taxSchemeID;

		if (!schemeID) {
			return;
		}

		defaultTax({
			variables: {
				accountID: user.accountID,
				taxSchemeID: schemeID,
				orderID,
			},
		});
	}, [getOutlet, orderID, hasAuth]);

	const taxAmount = taxType => {
		let totalTax;
		if (taxType === SchemeType?.ServiceCharge) {
			totalTax = taxSchemeInfo?.totalSC;
		} else if (taxType === SchemeType?.SST) {
			totalTax = taxSchemeInfo?.totalSST;
		} else if (taxType === SchemeType?.GST) {
			totalTax = taxSchemeInfo?.totalGST;
		}
		return totalTax;
	};

	return (
		<>
			{getTaxSchemeDetail?.map((x, index) => {
				return (
					<>
						{type === 'detail' ? (
							takeaway ? (
								<div
									key={index}
									className="m-t-10"
									style={{ display: 'flex', width: '100%' }}
								>
									{x?.taxType !== 'ServiceCharge' ? (
										<>
											<span className="mdDesc flex-space">
												{x?.taxCode} ({x?.taxRate}%)
											</span>
											<span className="mdDesc">{`${currencyCode}${amtStr(
												Number(taxAmount(x?.taxType)),
											)}`}</span>
										</>
									) : null}
								</div>
							) : (
								<div
									key={index}
									className="m-t-10"
									style={{ display: 'flex', width: '100%' }}
								>
									<span className="mdDesc flex-space">
										{x?.taxCode} ({x?.taxRate}%)
									</span>
									<span className="mdDesc">{`${currencyCode}${amtStr(
										Number(taxAmount(x?.taxType)),
									)}`}</span>
								</div>
							)
						) : type === 'receipt' ? (
							<div
								key={index}
								className="m-t-10"
								style={{ display: 'flex', width: '100%' }}
							>
								<span
									className="flex-space mdDesc "
									style={{
										alignSelf: 'center',
										fontSize: '16px',
										color: '#212121',
									}}
								>
									{x?.taxCode} ({x?.taxRate}%)
								</span>
								<span
									className="xsTitle rightText"
									style={{ fontSize: '16px', color: '#212121' }}
								>{`${currencyCode}${amtStr(
									Number(taxAmount(x?.taxType)),
								)}`}</span>
							</div>
						) : null}
					</>
				);
			})}
		</>
	);
};
